module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_vm._v("\n  Welcome Researcher!\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e85642a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/researcher/ResearcherHome.vue
// module id = 776
// module chunks = 1